module.exports = __webpack_public_path__ + "img/pic40.7b1eaae0.png";